'use es6';

import { Record } from 'immutable';
const ConnectedAccountRecord = Record({
  emailAddress: null,
  inboxType: null,
  isEnabled: null,
  hasConnectionError: null
}, 'ConnectedAccountRecord');
export default ConnectedAccountRecord;